import { useNavigation } from 'react-router-dom'
import LinearProgress from '@mui/material/LinearProgress'

const MainToolbarLinearProgress = () => {
  const navigation = useNavigation()
  return (
    <div className={`linear-progress ${navigation.state !== 'idle' ? 'show' : 'hide'}`}>
      <LinearProgress />
    </div>
  )
}

export default MainToolbarLinearProgress
